import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { locale } from '../../../utils/i18n';
import { EVENT, log } from '../../../common/logger';
import { staticPath, getKey } from '../../../utils/common';
import QrController from '../../../controllers/qr';
import CONSTANT, { RESPONSE_STATUS } from '../../../utils/constants';
import ProcessLoader from '../../ProcessLoader';
import { getApi } from '../../../utils/api-response-utils';

function isDigit(input) {
  return /^[0-9]+$/.test(input);
}

const PRN_LENGTH = 8;

class PRN extends Component {
  state = {
    showError: false,
    error: '',
    showLoader: false,
    prn: '',
    timeout: null
  };

  componentDidMount() {
    if (this.props && this.props.qr) {
      this.setState({
        timeout: setTimeout(() => {
          QrController.checkTransactionStatus();
        }, this.props.qr.pageTimeout)
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.timeout);
    this.setState({ timeout: null });
  }

  onKeyDownBox = event => {
    const element = event.target;
    const elementIndex = Number(element.getAttribute(`data-key`).replace('box-', ''));

    if (
      (event.which === 8 || event.while === 46) &&
      (elementIndex > 0 && getKey(element, 'previousSibling.focus'))
    ) {
      // in case of backspace or delete key press move to previous element
      element.previousSibling.focus();
    }

    if (!isDigit(element.value)) {
      element.value = '';
      return;
    }

    if (elementIndex < PRN_LENGTH - 1 && getKey(element, 'nextSibling.focus')) {
      element.nextSibling.focus();
    }
  };

  initInputBox = () => {
    return Array.from({ length: PRN_LENGTH }).map((_, index) => (
      <input
        key={`box-${index}`}
        data-type="prn-box"
        className="ptm-pnr-input"
        data-key={`box-${index}`}
        type="text"
        maxLength="1"
        onKeyDown={event => {
          setTimeout(() => {
            this.onKeyDownBox(event);
          }, 0);
        }}
      />
    ));
  };

  verifyPRN = () => {
    const inputBoxes = document.querySelectorAll('input[data-type="prn-box"]');
    const prn = Array.from(inputBoxes).reduce((acc, inputBox) => acc + inputBox.value, '') || '';

    if (prn.length !== PRN_LENGTH) {
      // invalid prn
      this.setState({ showError: true, error: locale('qr.prn.incorrect') });
      return;
    }

    // disabled verify button and show loader on it
    this.setState({
      showError: false,
      showLoader: true
    });

    getApi(this.props.cache)
      .validatePRN({ prnCode: prn })
      .then(res => {
        const { status, retryAllowed, resultInfo } = res.body;

        log({
          eventType: EVENT.PRN_VALIDATE_API,
          apiStatus: true,
          status,
          retryAllowed
        });

        if (status === RESPONSE_STATUS.SUCCESS) {
          QrController.checkTransactionStatus();
        } else if (retryAllowed) {
          // show error message to user
          this.setState({
            showError: true,
            error: resultInfo.resultMsg,
            showLoader: false
          });
        } else {
          QrController.checkTransactionStatus();
        }
      })
      .catch(err => {
        let msg = '';

        if (getKey(err, 'body.resultInfo.resultStatus') === RESPONSE_STATUS.F) {
          const { resultInfo, retryAllowed } = err.body;

          log({
            eventType: EVENT.PRN_VALIDATE_API,
            apiStatus: false,
            retryAllowed,
            message: resultInfo.resultMsg
          });

          if (retryAllowed) {
            msg = resultInfo.resultMsg;
          } else {
            QrController.checkTransactionStatus();
            return;
          }
        } else {
          msg = CONSTANT.GENERIC_ERROR;
        }

        this.setState({
          showError: true,
          error: msg,
          showLoader: false
        });
      });
  };

  render({}, { showError, error, showLoader }) {
    return (
      <div className="ptm-pnr-overlay" data-key="prn-section">
        <div className="ptm-pnr-container ptm-body-bg">
          <div className="ptm-pnr-inner paytm-txt-center">
            <img
              src={`${staticPath()}/assets/images/qr-succes.png`}
              className="ptm-prn-img"
              alt="prn success"
              data-key="prn-success"
            />
            <h6 className="ptm-pnr-heading ptm-body-color">{locale('qr.prn')}</h6>
            <p className="ptm-pnr-description paytm-txt-center ptm-body-color">
              {locale('qr.prn.description')}
            </p>
            <div className="ptm-pnr-box">
              {this.initInputBox()}
              {showError && (
                <p className="ptm-pnr-error paytm-txt-center" data-key="prn-error">
                  {error}
                </p>
              )}
              <div className="ptm-pnr-verify">
                <button disabled={showLoader} className="ptm-custom-btn" onClick={this.verifyPRN}>
                  {!showLoader && locale('login.btn.verifyOtp.text')}
                  {showLoader && (
                    <div class="ptm-inline-spinner">
                      <ProcessLoader />
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect('cache')(PRN);



// WEBPACK FOOTER //
// ./components/qr/prn/index.js